export default "pagination";
